import React, { memo } from 'react'
import ControlledFacet from 'transfix-form/components/ControlledFacet'
import { IControlledFacetProps } from 'transfix-form/components/ControlledFacet/ControlledFacet'
import { TEST_IDS } from 'transfix-form/forms/SavedLaneForm/constants'
import { FormHelperText } from 'transfix-ui/components/FormHelperText'
import Grid from 'transfix-ui/core/Grid'
import { DAY_OPTIONS } from '../constants'

export interface IControlledCheckboxDaysProps
  extends Pick<IControlledFacetProps, 'control' | 'name'> {
  errors?: string
}

const ControlledCheckboxDays = memo<IControlledCheckboxDaysProps>(({ control, errors, name }) => {
  return (
    <Grid container spacing={1}>
      {DAY_OPTIONS.map(({ label, value }) => (
        <Grid item key={value}>
          <ControlledFacet
            control={control}
            id={value}
            name={`${name}.${value}`}
            label={label}
            dataTest={`${TEST_IDS.dayOfWeekSingleSelect}-${label}`}
          />
        </Grid>
      ))}
      {!!errors && (
        <Grid item xs={12}>
          <FormHelperText className='Mui-error'>{errors}</FormHelperText>
        </Grid>
      )}
    </Grid>
  )
})

export default ControlledCheckboxDays
